import InstructionHand from 'app/display/ui/InstructionHand';
import HudLevelCountdown from 'app/ui/hud/HudLevelCountdown';

export default class GameTutorialController extends Phaser.Group {
  constructor({ game, mapController, dennis }) {
    super(game);

    this.onComplete = new Phaser.Signal();
    this.active = true;
    this.control = this.game.make.image(0, 0, '');
  }

  nextStep() {
    switch (this.state) {
      case GameTutorialController.STATE_IDLE:
        break;
    }
  }

  dispatchComplete() {
    this.active = false;
    this.countdown.onComplete.remove(this.dispatchComplete, this);
    this.onComplete.dispatch();
  }
  update() {
    switch (this.state) {
    }
  }

  destroy() {
    this.countdown.destroy();
    super.destroy(true);
  }
}
